import React, { useEffect, useState } from "react";
import ConnectedDevicesBox from "./ConnectedDevicesBox";
import DisconnectedDevicesBox from "./DisconnectedDevicesBox";
import ComplianceDevicesBox from "./ComplianceDevicesBox";
import BaselineViolationsDevicesBox from "./BaselineViolationsDevicesBox";
import { getDevicesStatus, getViolationsStatus } from "./infoBoxesService";
// import {useLocation} from "react-router-dom";

export const INFO_BOXES_REFRESH_EVENT = "octopus:info-boxes-refresh";

export function InfoBoxes() {

    // const location = useLocation();
    const [deviceWidgetsData, setDeviceWidgetsData] = useState({});
    const [violationWidgetData, setViolationWidgetData] = useState({});

    const setDeviceAndViolation = async () => {
        const devicesStatus = await getDevicesStatus();
        const violationsStatus = await getViolationsStatus();

        setDeviceWidgetsData(devicesStatus);
        setViolationWidgetData(violationsStatus);
    }

    useEffect(() => {
        setDeviceAndViolation();

        const refreshInfoBoxes = () => {
            setDeviceAndViolation();
        };

        window.addEventListener(INFO_BOXES_REFRESH_EVENT, refreshInfoBoxes);

        return () => {
            window.removeEventListener(INFO_BOXES_REFRESH_EVENT, refreshInfoBoxes);
        };
    }, [])
    //Added lastMonthCompliance, compliance to the ComplianceDevicesBox by Octopus DevTeam Dec 19,2022

    return (
        <div className="oct_info-boxes-updated">
            <div className="container-fluid">
                <div className="row justify-content-lg-between">
                    <ConnectedDevicesBox value={deviceWidgetsData.connected} percentage={deviceWidgetsData.connectedSinceLastMonth} />
                    <DisconnectedDevicesBox value={deviceWidgetsData.disconnected} percentage={deviceWidgetsData.disconnectedSinceLastDay} />
                    <BaselineViolationsDevicesBox value={violationWidgetData.violations} percentage={violationWidgetData.violationsSinceLastMonth} />
                    <ComplianceDevicesBox value={violationWidgetData.compliance} percentage={violationWidgetData.complianceSinceLastMonth} lastMonthCompliance={violationWidgetData.lastMonthCompliance} compliance={violationWidgetData.compliance} />
                </div>
            </div>
        </div>
    )

}
